import { useMemo } from 'react';

import { ListItemAvatar, ListItemText } from '@material-ui/core';

import { IdentityFragment, isType } from '@spotify/confidence-graphql';

import { IdentityUtils, identityKind } from '../../utils';
import { IdentityAvatar } from '../IdentityAvatar';

type IdentityListItemProps = {
  identity: IdentityFragment;
};

export function IdentityItem({ identity }: IdentityListItemProps) {
  const isUser = identityKind(identity.name) === 'user';
  const { displayName } = useMemo(() => {
    if (isType(identity.user, 'IamV1User')) {
      return {
        displayName: identity?.user.fullName,
        secondary: identity?.user.email,
      };
    }
    if (isType(identity.apiClient, 'IamV1ApiClient')) {
      return {
        displayName: identity?.apiClient.displayName,
        secondary: identity?.apiClient.description,
      };
    }
    if (isType(identity.group, 'IamV1Group')) {
      return {
        displayName: identity?.group.displayName,
        secondary: identity?.group.description,
      };
    }
    return { secondary: null, displayName: identity.displayName };
  }, [identity]);
  return (
    <>
      <ListItemAvatar>
        <IdentityAvatar identityRef={identity} />
      </ListItemAvatar>
      <ListItemText
        {...(isUser ? { 'data-csr-mask': true } : {})}
        primary={displayName}
        primaryTypographyProps={{ noWrap: true, style: { maxWidth: '80%' } }}
        secondary={IdentityUtils.getIdentityDescription(identity)}
        secondaryTypographyProps={{ noWrap: true, style: { maxWidth: '80%' } }}
      />
    </>
  );
}
